module.exports = __webpack_public_path__ + "static/img/peas-fairy.b4b5b02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peas-fairy.jpg
// module id = j6LG
// module chunks = 0